import { AppBar, Container, Toolbar, Typography,Tooltip, IconButton } from '@mui/material';
import React, { useEffect } from 'react';
import { mainColor } from '../../constants';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import {  useSelector,useDispatch } from 'react-redux';
import { auth } from '../../firebaseConfig';
import { loggedOutSuccess } from '../../redux/authSlice';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import MenuIcon from '@mui/icons-material/Menu';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
function LoginHeader(props) {
  const dispatch=useDispatch();
  const routeName=window.location.pathname
  const token = useSelector((state) => state.auth.token);
    const signOut = async () => {
    try {
      await auth.signOut();
      setOpen(false);
      dispatch(loggedOutSuccess());
    } catch (e) {
      // console.log(e.message);
    }
  };
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

if(routeName=="/pp") return null
  return (
    <AppBar
      position="relative"
      sx={{
      flexGrow: 1,
      marginBottom:20,
      backgroundColor: mainColor,
      margin: 0,
      // width:`calc(100% - 240px)`,
      height:60,
      zIndex:99
    }}
      style={{ backgroundColor: mainColor }}
    >
      <Container maxWidth="xl">
        <Toolbar  sx={{
              pr: '24px', // keep right padding when drawer closed
            }}>
          <IconButton
              edge="start"
              color="inherit"
              aria-label="open drawer"
              onClick={props.toggleDrawer}
              sx={{
                marginRight: '36px',
                ...((props.drawerStatus ||!token)&& { display: 'none' }),
              }}
            >
              <MenuIcon />
            </IconButton>
          <Typography
            noWrap
            component="a"
            style={{ display: 'flex', cursor: 'pointer' }}
            variant="h6"
            sx={{
              mr: 2,
              // ml:2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
              fontWeight: 700,
              color: 'white',
            }}
          >
            Expert Minute
          </Typography>
            {token && (
                    <Tooltip
                    title="Log out"
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                    >
                    <ExitToAppIcon
                        style={{
                        color: "#ebebeb",
                        marginLeft: '5px',
                        cursor: 'pointer',
                        height: 40,
                        width:40,
                        }}
                        onClick={handleClickOpen}
                    />
                    </Tooltip>
                )}
                    {token&&<Dialog
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">
                        {"Log out!"}
                        </DialogTitle>
                        <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Are you sure tha you want to log out?
                        </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button onClick={signOut} sx={{color:"red"}} autoFocus>
                            Confirm
                        </Button>
                        </DialogActions>
                    </Dialog>}
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default LoginHeader;
